// Import dependencies
import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Paper } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import useStyles from "./styles";
import { createPost, updatePost } from "../../actions/posts";

// Form structure and design
const Form = ({ currentId, setCurrentId }) => {
  //set initial meme(postData)
  const [postData, setPostData] = useState({
    name: "",
    caption: "",
    url: "",
  });

  // Checks if meme is new(currentId=0) or being edited(currentId!=0)
  const post = useSelector((state) =>
    currentId ? state.posts.find((message) => message.id === currentId) : null
  );

  const dispatch = useDispatch();
  const classes = useStyles();

  // Update posts effectively
  useEffect(() => {
    if (post) setPostData(post);
  }, [post]);

  // Clears from and sets post to initial state
  const clear = () => {
    setCurrentId(0);
    setPostData({
      name: "",
      caption: "",
      url: "",
    });
  };

  // Checks and submits the form data
  const handleSubmit = async (e) => {
    e.preventDefault();

    // New Meme
    if (currentId === 0) {
      dispatch(createPost(postData));

      // Reloads browser to see updated changes
      clear();
      // window.location.reload();
    } else {
      // Editing a meme
      dispatch(updatePost(currentId, postData));
      clear();
    }
  };

  return (
    <Paper className={classes.paper}>
      <form
        autoComplete="off"
        noValidate
        className={`${classes.root} ${classes.form}`}
        onSubmit={handleSubmit}
      >
        <Typography variant="h6">
          {currentId ? "Edit Meme" : "Post a Meme"}
        </Typography>
        <TextField
          name="name"
          variant="outlined"
          label="Name"
          placeholder="Enter your name"
          fullWidth
          value={postData.name}
          disabled={currentId !== 0}
          onChange={(e) => setPostData({ ...postData, name: e.target.value })}
        />
        <TextField
          name="caption"
          variant="outlined"
          label="Caption"
          fullWidth
          value={postData.caption}
          onChange={(e) =>
            setPostData({ ...postData, caption: e.target.value })
          }
        />
        <TextField
          name="url"
          variant="outlined"
          label="Url of meme"
          fullWidth
          value={postData.url}
          onChange={(e) => setPostData({ ...postData, url: e.target.value })}
        />
        <Button
          className={classes.buttonSubmit}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          disabled={
            postData.name.length === 0 ||
            postData.caption.length === 0 ||
            postData.url.length === 0
          }
          fullWidth
        >
          Submit
        </Button>
        <Button
          variant="contained"
          color="secondary"
          size="small"
          disabled={
            postData.name.length === 0 &&
            postData.caption.length === 0 &&
            postData.url.length === 0
          }
          onClick={clear}
          fullWidth
        >
          Clear
        </Button>
      </form>
    </Paper>
  );
};

export default Form;
